import React from 'react';

export default function PayrollTopBar({ selectedUser, salaryState, workingDaysOfMonth, showThirdColumn }) {
  if (!selectedUser) return null;

  const netPay = salaryState?.totalSalary || 0;
  const baseSalary = salaryState?.baseSalary || 0;
  const status = showThirdColumn ? 'generated' : 'pending';

  return (
    <div className="pr-topbar">
      <div className="pr-topbar-left">
        <h2>{selectedUser.username || selectedUser.fullName || selectedUser.name}</h2>
        <p>
          {(selectedUser.roles && selectedUser.roles[0]) || 'Staff'}
          {selectedUser.joiningDate && (' \u00B7 Joined ' + selectedUser.joiningDate.slice(0, 10))}
        </p>
      </div>

      <div className="pr-topbar-right">
        {(showThirdColumn || baseSalary > 0) && (
          <span className="pr-kpi-pill violet">
            {showThirdColumn ? ('Net: \u20B9' + netPay.toLocaleString()) : ('Base: \u20B9' + baseSalary.toLocaleString())}
          </span>
        )}
        <span className="pr-kpi-pill teal">
          {workingDaysOfMonth} days
        </span>
        <span className={'pr-status-badge ' + status}>
          {status === 'generated' ? 'Generated' : 'Pending'}
        </span>
      </div>
    </div>
  );
}
